module.exports = __webpack_public_path__ + "static/media/farm-credit-dark-mode.38782edf.png";